import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 57 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.64.383 14.18 18.765H9.31L5.635 4.095c-.22-.901-.418-1.232-1.093-1.616C3.437 1.854 1.605 1.278 0 .918L.11.383h7.84c1 0 1.896.685 2.123 1.874l1.942 10.64L16.808.384h4.838zM40.716 12.76c.023-4.853-6.496-5.123-6.45-7.29.012-.661.623-1.364 1.954-1.538.658-.09 2.478-.162 4.543.823L41.57.858C40.46.443 39.035.047 37.26.047c-4.553 0-7.758 2.498-7.781 6.077-.03 2.648 2.285 4.12 4.03 5.002 1.797.901 2.396 1.477 2.39 2.282-.011 1.231-1.43 1.778-2.756 1.802-2.315.036-3.658-.649-4.728-1.165l-.838 4.03c1.076.51 3.065.954 5.118.972 4.839 0 8.008-2.468 8.02-6.293m12.027 6.01H57L53.278.385h-3.931c-.885 0-1.635.528-1.96 1.35l-6.91 17.037h4.84l.959-2.745h5.909l.558 2.745zm-5.141-6.515 2.425-6.906 1.396 6.906zM28.224.383l-3.81 18.382h-4.606L23.618.383z"
    }, null, -1)
  ])))
}
export default { render: render }